// TODO @cleanup just use from Stem utils
import {WIDGET_KEYBOARD_TOGGLED_THRESHOLD} from "./widget/WidgetConstants";

export * from "./UtilsLib"; // TODO: functions from UtilsLib should be imported directly from there.

export function isIframe(): boolean {
    return window.parent && window.parent !== window;
}

export function normalize(text: string): string {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function isStorageDisabled(): boolean {
    try {
        window.localStorage;
        return false;
    } catch (e) {
        return true;
    }
}

export function isThirdPartyStorageBlocked(): boolean {
    return isStorageDisabled();
}

export function isFacebookBrowser(): boolean {
    const {userAgent} = navigator;

    return userAgent.indexOf("FBAN") > -1 || userAgent.indexOf("FBAV") > -1;
}

export function bytesToSize(bytes: number): string {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) {
        return "n/a";
    }
    const i = Math.floor(Math.log(bytes) / Math.log(1024)) | 0;
    if (i === 0) {
        return bytes + " " + sizes[i];
    }
    let amount = (bytes / Math.pow(1024, i)).toFixed(1);
    let unit = sizes[i];
    if (!(amount && unit)) {
        return "-";
    }
    return amount + " " + unit;
}

export function closeWindow(): void {
    try {
        if (window.opener) {
            window.opener.focus();
        }
    } finally {
        window.close();
    }
}

export function isScrolledInViewport(node: Element | null, percent: number = 1): boolean {
    if (!node) {
        return false;
    }

    let {top, height} = node.getBoundingClientRect();
    if (!height) {
        return false;
    }
    let windowHeight = window.innerHeight;

    if (window.visualViewport) {
        top -= window.visualViewport.offsetTop;
        windowHeight = window.visualViewport.height;
    }

    return (windowHeight - top) / windowHeight >= percent;
}

export function getOpenerOrigin(): string | null {
    // Accessing an opener origin that differs from the current one throws error.
    try {
        return (window.opener === window) ? null : window.opener.origin;
    } catch (e) {
        return null;
    }
}

export function isNetworkError(error: any): boolean {
    return error?.detail === "Network error";
}

export function isKeyboardExpanded(): boolean {
    return window.innerHeight < WIDGET_KEYBOARD_TOGGLED_THRESHOLD && document.activeElement !== document.body;
}